<template>
  <div>
    <modify-currency-popup
      :show="ModifyPopup"
      @finish="onfinish"
      @close="closeModifyPopup"
    >
    </modify-currency-popup>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%" class="border-0">{{ $t("RequesterName") }}</th>
                  <th style="width: 14%" class="border-0">{{ $t("RequesterUsername") }}</th>
                  <th style="width: 10%" class="border-0">{{ $t("Departman") }}</th>
                  <th style="width: 10%" class="border-0">{{ $t("Supplier") }}</th>
                  <th style="width: 10%" class="border-0">{{ $t("CurrencyType") }}</th>
                  <th style="width: 13%" class="border-0">{{ $t("DeliveryDate") }}</th>
                  <th style="width: 13%" class="border-0">{{ $t("CreateOn") }}</th>
                  <th style="width: 40%" class="border-0">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%" class="border-0">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.currencyType === 1 ? "ریال" : model.currencyType === 2 ? "دلار":model.currencyType === 3 ? "درهم" :"-"
                    }}
                  </td>
                  <td style="width: 20%" class="border-0">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 13%" class="border-0">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>
                  <!-- <td style="width: 13%">
                    <v-select
                      class="m-0"
                      label="name"
                      name="unit"
                      :options="allCurrency"
                      v-model="model.currencyType"
                      :reduce="(x) => x.id"
                      :disabled="!editCurrencyClicked"
                      dir="rtl"
                    >
                    </v-select>
                  </td> -->
                  <td style="width: 33%" class="border-0">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="
              model.purchaseOrderItems && model.purchaseOrderItems.length > 0
            "
          >
            <vs-table :data="model.purchaseOrderItems" class="custom-tbl" id="colored-table">
              <template slot="thead">
                <th style="width: 20%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("CountOfPurchaseOrder") }}</th>
                <th style="width: 10%">
                  {{ $t("CountOfPurchaseOrderRegistered") }}
                </th>
                <th style="width: 5%">{{ $t("Count") }}</th>
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">{{ $t("AmountSourceCurrencyWithDeduction") }}</th>

                <!-- <th style="width: 10%">{{ $t("EffectiveAmount") }}</th> -->
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseOrderProductInfo.itemCode }}
                  </vs-td>

                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <vs-td>
                    {{ row.countOfInvoiceRegistered }}
                  </vs-td>
                  <vs-td>
                    <vs-input v-model="row.remainingCount" name="count" />
                  </vs-td>
                  <vs-td>
                    {{ formatPrice(row.unitPrice) }}
                  </vs-td>
                  <vs-td>
                    {{ row.unitPriceAfterDeductionAndIncrease ? formatPrice(row.unitPriceAfterDeductionAndIncrease) :'-'}}
                  </vs-td>
                  <!-- <vs-td style="direction: ltr;">
                    {{ formatPrice(row.purchaseOrderEffectiveAmount) }}
                  </vs-td> -->
                  <vs-td>
                    {{ formatPrice(row.amount) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end mt-3 w-full px-5">
            <table class="basic-tbl w-1/4 total" id="colored-table">
              <thead class="border-0">
                <tr>
                  <th style="width: 10%">
                    {{ $t("TotalAmount") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%" class="border-0">
                    {{
                      model.totalAmount ? formatPrice(model.totalAmount) : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex justify-end w-full mt-5">
            <div class="ml-4">
              <!-- <vs-button
                v-if="editUnitClicked"
                type="filled"
                @click.prevent="saveUnit"
              >
                <span> {{ $t("SaveUnitPrice") }}</span>
              </vs-button>
              <vs-button v-else type="filled" @click.prevent="editUnit">
                <span> {{ $t("EditUnitPrice") }}</span>
              </vs-button> -->
    

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-end w-full ml-4 mt-10">
      <vs-button
        v-has-permission="'GotoClose'"
        type="filled"
        color="success"
        class="mr-5"
        @click.prevent="accept"
      >
        <span> {{ $t("Save") }}</span>
      </vs-button>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
import { mapActions } from "vuex";
import Treeselect from "@/components/CustomTreeSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ModifyCurrencyPopup from "./ModifyCurrencyPopup.vue";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    "v-select": vSelect,
    Treeselect,
    ModifyCurrencyPopup,
  },
  data() {
    var id = this.$route.params.id;

    return {
      ModifyPopup: false,
      model: {},
      editable: true,
      editCurrencyClicked: false,
      pOId: -1,
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrderById: "purchaseInvoice/fetchPurchaseOrderById",
      savePurchaseInvoice: "purchaseInvoice/savePurchaseInvoice",
      saveCurrencyFunction: "purchaseInvoice/saveCurrency",
    }),
    load() {
      var id = this.$route.params.id;
      this.pOId = this.$route.params.id;
      this.fetchPurchaseOrderById(id).then((r) => {
        this.model = r;
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
      this.load();
    },
    onfinish() {
      this.closeModifyPopup();
    },
    editCurrency() {
      this.ModifyPopup = true;
    },

    // saveCurrency() {
    //   const payload = {
    //     id: this.model.id,
    //     currencyType: this.model.currencyType,
    //   };
    //   console.log(payload)
    //   this.saveCurrencyFunction(payload).then((r) => {
    //     this.$swal({
    //       position: "center-center",
    //       type: "success",
    //       text: "نوع ارز مورد نظر ویرایش شد",
    //       showConfirmButton: false,
    //       timer: 2000,
    //     }).then(() => {
    //       this.editCurrencyClicked = false;
    //     }).catch(()=>{
    //       console.log('error')
    //     });
    //   });
    // },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    reject() {
      this.$swal({
        position: "center-center",
        text: "آیا از رد این پیش فاکتور اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.rejectPurchaseInvoice({ id: this.model.id }).then((r) => {
            this.$swal({
              position: "center-center",
              type: "danger",
              text: "پیش فاکتور خرید مورد نظر رد شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
    accept() {
      var preInvoiceItems = [];
      this.model.purchaseOrderItems.forEach((element) => {
        var x = {
          modelNumber: element.purchaseOrderProductInfo.modelNumber,
          count: element.remainingCount,
        };
        preInvoiceItems.push(x);
      });
      const payload = {
        purchaseOrderId: this.model.id,
        description: this.model.description,
        purchaseInvoiceItems: preInvoiceItems,
      };
      this.$swal({
        position: "center-center",
        text: "آیا از ثبت این پیش فاکتور اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          console.log(payload);
          this.savePurchaseInvoice(payload).then((r) => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "پیش فاکتور خرید مورد نظر تایید شد",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
          });
        }
      });
    },
  },
};
</script>
<style>
body[dir="rtl"] table thead th {
  position: static;
}
.total thead {
  border: 1px solid;
  
} 
#colored-table thead tr th{
  color: white;
}
</style>
